const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="lucide lucide-calendar-icon lucide-calendar"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M7.636 0a1.09 1.09 0 0 0-1.09 1.09v4.365a1.09 1.09 0 0 0 1.09 1.09 1.09 1.09 0 0 0 1.091-1.09V1.09A1.09 1.09 0 0 0 7.637 0"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M16.364 0a1.09 1.09 0 0 0-1.091 1.09v4.365a1.09 1.09 0 0 0 1.09 1.09 1.09 1.09 0 0 0 1.092-1.09V1.09A1.09 1.09 0 0 0 16.364 0"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M4.364 2.182A3.29 3.29 0 0 0 1.09 5.455v15.272A3.29 3.29 0 0 0 4.364 24h15.272a3.29 3.29 0 0 0 3.273-3.273V5.455a3.29 3.29 0 0 0-3.273-3.273zm0 2.182h15.272c.624 0 1.091.467 1.091 1.09v15.273c0 .624-.467 1.091-1.09 1.091H4.363c-.624 0-1.091-.467-1.091-1.09V5.454c0-.624.467-1.091 1.09-1.091"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M2.182 8.727A1.09 1.09 0 0 0 1.09 9.818a1.09 1.09 0 0 0 1.09 1.091h19.637a1.09 1.09 0 0 0 1.091-1.09 1.09 1.09 0 0 0-1.09-1.092Z"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
